export default {
  components: {},
  data: () => ({
    blog: {
      title: "",
    },
  }),

  mounted() {
    this.$axios.get("/blog/" + this.$route.params.blog_id).then((res) => {
      if (res) {
        this.blog = res.data.blog;
        document.title = res.data.blog.title;

        // var ogTitle = document.createElement("meta");
        // ogTitle.setAttribute("property", "og:title");
        // ogTitle.content = res.data.blog.title;
        // document.getElementsByTagName("head")[0].appendChild(ogTitle);

        document
          .querySelectorAll("meta[property=og\\:title]")[0]
          .setAttribute("content", res.data.blog.title);

        document
          .querySelectorAll("meta[property=og\\:image]")[0]
          .setAttribute("content", res.data.blog.thumbnail_url);

        document
          .querySelectorAll("meta[property=og\\:description]")[0]
          .setAttribute("content", res.data.blog.description);
      }
    });
  },
};
